import Carousel from "nuka-carousel";
import Logo from "../acepts/tahlil.svg";
import "./sport.css";
import { NavLink } from 'react-router-dom';

export function Carusel2() {
  return (
    <div>
      <div className="sport_title">
        <div className="sport_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/slide15-390x220.jpg"
            alt="img error"
          />
          <button className="sport_box_btn" type="text" disabled>
            Football
          </button>
        </div>
        <div className="sport_box_right">
          <div className="sport_box_data">
            <span>
              <i class="bi bi-clock me-2"></i>Tony Stark{" "}
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <span className="sport_data_right">
              <p>
                <i class="bi bi-clock me-2"></i> 0,
              </p>{" "}
              <p className="sport_fire">
                <i class="bi bi-clock me-2"></i> 15.308
              </p>
            </span>
          </div>
          <h1> Les nouveaux maillots du Real Madrid pour la saison</h1>
          <p>
            Stay focused and remember we design the best WordPress News and
            Magazine Themes. It’s the ones closest to you that want to…
          </p>
          <button>
            Read More <i class="bi bi-clock me-2"></i>
          </button>
        </div>
      </div>
      <div className="sport_gallery">
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
export function Carusel3() {
  return (
    <div>
      <div className="sport_title">
        <div className="sport_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/slide15-390x220.jpg"
            alt="img error"
          />
          <button className="sport_box_btn" type="text" disabled>
            Football
          </button>
        </div>
        <div className="sport_box_right">
          <div className="sport_box_data">
            <span>
              <i class="bi bi-clock me-2"></i> Tony Stark{" "}
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <span className="sport_data_right">
              <p>
                <i class="bi bi-clock me-2"></i> 0,
              </p>{" "}
              <p className="sport_fire">
                <i class="bi bi-clock me-2"></i> 15.308
              </p>
            </span>
          </div>
          <h1> Les nouveaux maillots du Real Madrid pour la saison</h1>
          <p>
            Stay focused and remember we design the best WordPress News and
            Magazine Themes. It’s the ones closest to you that want to…
          </p>
          <button>
            Read More <i class="bi bi-clock me-2"></i>
          </button>
        </div>
      </div>
      <div className="sport_gallery">
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Carusel4() {
  return (
    <div>
      <div className="sport_title">
        <div className="sport_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/slide15-390x220.jpg"
            alt="img error"
          />
          <button className="sport_box_btn" type="text" disabled>
            Football
          </button>
        </div>
        <div className="sport_box_right">
          <div className="sport_box_data">
            <span>
              <i class="bi bi-clock me-2"></i> Tony Stark{" "}
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <span className="sport_data_right">
              <p>
                <i class="bi bi-clock me-2"></i> 0,
              </p>{" "}
              <p className="sport_fire">
                <i class="bi bi-clock me-2"></i> 15.308
              </p>
            </span>
          </div>
          <h1> Les nouveaux maillots du Real Madrid pour la saison</h1>
          <p>
            Stay focused and remember we design the best WordPress News and
            Magazine Themes. It’s the ones closest to you that want to…
          </p>
          <button>
            Read More <i class="bi bi-clock me-2"></i>
          </button>
        </div>
      </div>
      <div className="sport_gallery">
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
        <div className="sport_gal_box">
          <img
            src="https://jannah.tielabs.com/demo/wp-content/uploads/sites/8/2016/10/image9-220x150.jpg"
            alt="error img"
          />
          <div className="sport_gal_text">
            <span>
              <i class="bi bi-clock me-2"></i> Oct 6, 2016
            </span>
            <h3>I enjoy hard work I love setting goals and achieving them</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Carusel() {
  return (
    <div>
      <Carousel
        defaultControlsConfig={{
          nextButtonText: ">",
          prevButtonText: "<",
          pagingDotsStyle: {
            fill: "none",
          },
        }}
      >
        <Carusel2 />
        <Carusel3 />
        <Carusel4 />
      </Carousel>
    </div>
  );
}

function Sport() {
  return (
    <div className="containers actual">
        <div className="video_title pb-3">
          <div className="video_title_text d-flex align-items-center">
            <img src={Logo} alt="Error img" />
            <h3 className="ms-2">Sport news</h3>
          </div>
          <h5 className="link_news"><NavLink to="/video">All News <i class="bi bi-arrow-right ms-2"></i></NavLink></h5>
        </div>
      <div className="sport" data-aos="zoom-out-up">
        <Carusel />
      </div>
    </div>
  );
}

export default Sport;
